import { useSelector, } from 'react-redux';
import { useEffect, } from 'react';
import { actionFetchStatsCustomMetrics, useAppDispatch, IReducerStore, } from '@Store';

let initiated = false;

export const useStatsCustomMetrics = (autoload: boolean = true) => {
  const dispatch = useAppDispatch();
  const stats_custom_metrics = useSelector((store: IReducerStore) => store.stats_custom_metrics);

  useEffect(() => {
    if (!initiated && autoload && !stats_custom_metrics.loaded && !stats_custom_metrics.loading) {
      initiated = true;
      dispatch(actionFetchStatsCustomMetrics());
    }
  }, [autoload, stats_custom_metrics.loaded, stats_custom_metrics.loading, dispatch, ]);

  return stats_custom_metrics;
};
